import React from "react";
import { WhmCard, WhmBox } from "@securitize/reactjs-whm";
import { DocumentDataGrid } from "../../components/documents/DocumentDataGrid";
import { useMediaQuery, useTheme } from "@mui/material";
import { DocumentsClient } from "../../data/clients";
import { DocumentDto } from "../../data/types";
import { ErrorPage } from "../../components/shared/ErrorPage";
import { PortfolioStatementButton } from "../../components/documents/PortfolioStatement";

export const Documents: React.FC = () => {
  const [documents, setDocuments] = React.useState<Array<DocumentDto>>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<boolean>(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const search = React.useCallback(async () => {
    try {
      setLoading(true);
      const data = await DocumentsClient.getDocuments();
      setDocuments(data);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    search();
  }, [search]);

  if (error) return <ErrorPage onRefresh={search} />;

  return (
    <WhmCard
      variant="outlined"
      sx={{
        marginTop: isMobile ? "8px" : "32px",
        backgroundColor: isMobile ? "#f7f7f7" : "#ffffff",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingBottom: "8px",
        paddingTop: !loading ? (isMobile ? "8px" : "16px") : "8px",
        ...(isMobile && { border: 0 }),
      }}
    >
      {!loading && (
        <WhmBox
          sx={{
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "flex-end",
            mb: 2,
          }}
        >
          <PortfolioStatementButton />
        </WhmBox>
      )}
      <DocumentDataGrid
        isMobile={isMobile}
        isLoading={loading}
        documents={documents}
        loadServerRows={search}
      />
    </WhmCard>
  );
};
